import {
  Route, Routes,
  useSearchParams,
  useLocation,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MainPage from './main/MainPage';
import CombinedReportPage from './reports/CombinedReportPage';
import PositionsReportPage from './reports/PositionsReportPage';
import ServerPage from './settings/ServerPage';
import UsersPage from './settings/UsersPage';
import DevicePage from './settings/DevicePage';
import UserPage from './settings/UserPage';
import NotificationsPage from './settings/NotificationsPage';
import NotificationPage from './settings/NotificationPage';
import GroupsPage from './settings/GroupsPage';
import GroupPage from './settings/GroupPage';
import PositionPage from './other/PositionPage';
import NetworkPage from './other/NetworkPage';
import EventReportPage from './reports/EventReportPage';
import GeofenceReportPage from './reports/GeofenceReportPage';
import ReplayPage from './other/ReplayPage';
import TripReportPage from './reports/TripReportPage';
import StopReportPage from './reports/StopReportPage';
import SummaryReportPage from './reports/SummaryReportPage';
import ChartReportPage from './reports/ChartReportPage';
import CorrelationReportPage from './reports/CorrelationReportPage';
import DriversPage from './settings/DriversPage';
import DriverPage from './settings/DriverPage';
import CalendarsPage from './settings/CalendarsPage';
import CalendarPage from './settings/CalendarPage';
import ComputedAttributesPage from './settings/ComputedAttributesPage';
import ComputedAttributePage from './settings/ComputedAttributePage';
import MaintenancesPage from './settings/MaintenancesPage';
import MaintenancePage from './settings/MaintenancePage';
import CorrelationsPage from './settings/CorrelationsPage';
import CorrelationPage from './settings/CorrelationPage';
import CommandsPage from './settings/CommandsPage';
import CommandPage from './settings/CommandPage';
import StatisticsPage from './reports/StatisticsPage';
import LoginPage from './login/LoginPage';
import RegisterPage from './login/RegisterPage';
import ResetPasswordPage from './login/ResetPasswordPage';
import GeofencesPage from './other/GeofencesPage';
import GeofencePage from './settings/GeofencePage';
import { useEffectAsync } from './reactHelper';
import { devicesActions } from './store';
import EventPage from './other/EventPage';
import PreferencesPage from './settings/PreferencesPage';
import AccumulatorsPage from './settings/AccumulatorsPage';
import CommandDevicePage from './settings/CommandDevicePage';
import CommandGroupPage from './settings/CommandGroupPage';
import App from './App';
import ChangeServerPage from './login/ChangeServerPage';
import DevicesPage from './settings/DevicesPage';
import ScheduledPage from './reports/ScheduledPage';
import DeviceConnectionsPage from './settings/DeviceConnectionsPage';
import GroupConnectionsPage from './settings/GroupConnectionsPage';
import UserConnectionsPage from './settings/UserConnectionsPage';
import LogsPage from './reports/LogsPage';
import SharePage from './settings/SharePage';
import AnnouncementPage from './settings/AnnouncementPage';
import EmulatorPage from './other/EmulatorPage';
import Loader from './common/components/Loader';
import { generateLoginToken } from './common/components/NativeInterface';
import { useLocalization } from './common/components/LocalizationProvider';
import fetchOrThrow from './common/util/fetchOrThrow';
/** MOD */
import UpdatesPage from './settings/UpdatesPage';
import DashboardPage from './settings/DashboardPage';
//import TelaLogs from './main/logs';
import RevendasPage from "./settings/RevendasPage";
import RevendaPage from "./settings/RevendaPage";
import WhatsappPage from "./settings/WhatsappPage";
// import InstallationPage from "./settings/InstallationPage";
// import InstallationsPage from "./settings/InstallationsPage";
import CostPage from "./settings/CostPage";
import CostsPage from "./settings/CostsPage";
import LicensesPage from "./settings/LicensesPage";
import TemperaturePage from "./temperature/TemperaturePage";
import SpeedingPage from "./management/SpeedingPage";
import EcoDrivingPage from "./management/EcoDrivingPage";
import TripsAnalysisPage from "./management/TripsAnalysisPage";
import PositionsHistoryPage from "./management/PositionsHistoryPage";
import DriverPerformancePage from "./management/DriverPerformancePage";
import ConfiguratorPage from "./configurator/ConfiguratorPage";
import AssistantPage from "./assistant/AssistantPage";
import FleetDashboardPage from "./management/FleetDashboardPage";
import PremiumDashboardPage from "./main/PremiumDashboardPage";
import DevicesReportPage from "./reports/DevicesReportPage";
import GeofencesReportPage from "./reports/GeofencesReportPage";
import CommandsReportPage from "./reports/CommandsReportPage";
import CostsReportPage from "./reports/CostsReportPage";
import CostsResumeReportPage from "./reports/CostsResumeReportPage";
import ActionsReportPage from "./reports/ActionsReportPage";
import OverviewPage from './main/OverviewPage';
import DriverScoreDashboard from './main/DriverScoreDashboard';
import MaintenanceDashboard from './main/MaintenanceDashboard';
import AuditPage from './reports/AuditPage';
import HeatmapPage from './other/HeatmapPage';
import EventMapPage from './other/EventMapPage';
import PoisPage from './settings/PoisPage';
import PoiPage from './settings/PoiPage';
import PoiGroupsPage from './settings/PoiGroupsPage';
import PoiGroupPage from './settings/PoiGroupPage';
import DevicePagePremium from './settings/premium/DevicePagePremium';
import RoutesPage from './settings/RoutesPage';
import RoutePage from './settings/RoutePage';
import {
 RoutePlanningPage, RouteExecutionPage, RoutingDashboardPage, OperationsCenterPage, DriverActivityDashboard 
} from './routing';
import TagsAdminPage from './settings/TagsAdminPage';
import {
  DriverLayout,
  DriverHomePage,
  DriverRoutesPage,
  DriverRouteExecutionPage,
  DriverNotificationsPage,
  DriverProfilePage,
  DriverSettingsPage,
  DriverHelpPage,
  DriverChatPage,
} from './driver';
// Camera Module
import { CameraDashboardPage, CameraSettingsPage, CameraViewPage, PlaybackPage, EventClipsPage } from './camera';

const Navigation = () => {
  const dispatch = useDispatch();
  const { setLocalLanguage } = useLocalization();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  // Páginas que usam deviceId como filtro de relatório - NÃO processar deviceId/follow nessas rotas
  const isReportPage = ['/eventmap', '/replay', '/heatmap', '/reports'].some(
    (path) => location.pathname.startsWith(path)
  );

  // deviceId e follow só devem ser processados na página principal, não em relatórios
  const hasQueryParams = [
    'locale',
    'token',
    'uniqueId',
    'openid',
    // deviceId e follow só são processados se NÃO estivermos em página de relatório
    ...(!isReportPage ? ['deviceId', 'follow'] : []),
  ].some((key) => searchParams.has(key));

  useEffectAsync(async () => {
    if (!hasQueryParams) {
      return;
    }

    const newParams = new URLSearchParams(searchParams);

    if (searchParams.has('locale')) {
      setLocalLanguage(searchParams.get('locale'));
      newParams.delete('locale');
    }

    if (searchParams.has('token')) {
      const token = searchParams.get('token');
      await fetch(`/api/session?token=${encodeURIComponent(token)}`);
      newParams.delete('token');
    }

    if (searchParams.has('uniqueId')) {
      const response = await fetchOrThrow(`/api/devices?uniqueId=${searchParams.get('uniqueId')}`);
      const items = await response.json();
      if (items.length > 0) {
        dispatch(devicesActions.selectId(items[0].id));
      }
      newParams.delete('uniqueId');
    }

    // deviceId e follow só são processados em páginas que não são relatórios
    if (searchParams.has('deviceId') && !isReportPage) {
      const deviceId = parseInt(searchParams.get('deviceId'), 10);
      if (deviceId && !Number.isNaN(deviceId)) {
        dispatch(devicesActions.selectId(deviceId));
      }
      newParams.delete('deviceId');
    }

    if (searchParams.has('follow') && !isReportPage) {
      const follow = searchParams.get('follow') === 'true';
      if (follow) {
        // Ativa o tail/rastro ao vivo salvando no localStorage
        try {
          const stored = localStorage.getItem('mapControlsSettings');
          const current = stored ? JSON.parse(stored) : {};
          localStorage.setItem('mapControlsSettings', JSON.stringify({ ...current, showTail: true }));
          // Dispara evento para atualizar o estado do mapa
          window.dispatchEvent(new CustomEvent('mapControlsChange', { detail: { key: 'showTail', value: true } }));
        } catch (e) {
          console.warn('Erro ao ativar trail:', e);
        }
      }
      newParams.delete('follow');
    }

    if (searchParams.has('openid')) {
      if (searchParams.get('openid') === 'success') {
        generateLoginToken();
      }
      newParams.delete('openid');
    }

    setSearchParams(newParams, { replace: true });
  }, [hasQueryParams, searchParams, setSearchParams]);

  if (hasQueryParams) {
    return (<Loader />);
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/change-server" element={<ChangeServerPage />} />
      <Route path="/" element={<App />}>
        <Route index element={<MainPage />} />

        <Route path="position/:id" element={<PositionPage />} />
        <Route path="network/:positionId" element={<NetworkPage />} />
        <Route path="event/:id" element={<EventPage />} />
        <Route path="replay" element={<ReplayPage />} />
        <Route path="heatmap" element={<HeatmapPage />} />
        <Route path="eventmap" element={<EventMapPage />} />
        <Route path="geofences" element={<GeofencesPage />} />
        <Route path="emulator" element={<EmulatorPage />} />
        <Route path="temperature" element={<TemperaturePage />} />
        <Route path="assistant" element={<AssistantPage />} />
        <Route path="fleet" element={<FleetDashboardPage />} />
        <Route path="dashboard-premium" element={<PremiumDashboardPage />} />
        {/* Camera System */}
        <Route path="camera" element={<CameraDashboardPage />} />
        <Route path="camera/:deviceId" element={<CameraViewPage />} />
        <Route path="camera/:deviceId/playback" element={<PlaybackPage />} />
        <Route path="camera/clips" element={<EventClipsPage />} />
        <Route path="camera/clips/:deviceId" element={<EventClipsPage />} />
        <Route path="camera/settings" element={<CameraSettingsPage />} />
        <Route path="camera/settings/:deviceId" element={<CameraSettingsPage />} />
      <Route path="/overview" element={<OverviewPage />} />
      <Route path="revendas" element={<RevendasPage />} />
      <Route path="costs" element={<CostsPage />} />
      <Route path="/CostsReportPage" element={<CostsReportPage />} />
      <Route path="/CostsResumeReportPage" element={<CostsResumeReportPage />} />
      <Route path="/ActionsReportPage" element={<ActionsReportPage />} />




        <Route path="settings">
          <Route path="accumulators/:deviceId" element={<AccumulatorsPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="announcement" element={<AnnouncementPage />} />
          <Route path="calendars" element={<CalendarsPage />} />
          <Route path="calendar/:id" element={<CalendarPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="commands" element={<CommandsPage />} />
          <Route path="command/:id" element={<CommandPage />} />
          <Route path="command" element={<CommandPage />} />
          <Route path="attributes" element={<ComputedAttributesPage />} />
          <Route path="attribute/:id" element={<ComputedAttributePage />} />
          <Route path="attribute" element={<ComputedAttributePage />} />
          <Route path="devices" element={<DevicesPage />} />
          <Route path="device/:id/connections" element={<DeviceConnectionsPage />} />
          <Route path="device/:id/command" element={<CommandDevicePage />} />
          <Route path="device/:id/share" element={<SharePage />} />
          <Route path="device/:id" element={<DevicePage />} />
          <Route path="command-send/:deviceId" element={<CommandsPage />} />
          <Route path="device/premium" element={<DevicePagePremium />} />
          <Route path="device/premium/:id" element={<DevicePagePremium />} />
          <Route path="device" element={<DevicePage />} />
          <Route path="drivers" element={<DriversPage />} />
          <Route path="driver/:id" element={<DriverPage />} />
          <Route path="driver" element={<DriverPage />} />
          <Route path="geofence/:id" element={<GeofencePage />} />
          <Route path="geofence" element={<GeofencePage />} />
          <Route path="groups" element={<GroupsPage />} />
          <Route path="group/:id/connections" element={<GroupConnectionsPage />} />
          <Route path="group/:id/command" element={<CommandGroupPage />} />
          <Route path="group/:id" element={<GroupPage />} />
          <Route path="group" element={<GroupPage />} />
          <Route path="maintenances" element={<MaintenancesPage />} />
          <Route path="maintenance/:id" element={<MaintenancePage />} />
          <Route path="maintenance" element={<MaintenancePage />} />
          <Route path="correlations" element={<CorrelationsPage />} />
          <Route path="correlation/:id" element={<CorrelationPage />} />
          <Route path="correlation" element={<CorrelationPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="notification/:id" element={<NotificationPage />} />
          <Route path="notification" element={<NotificationPage />} />
          <Route path="preferences" element={<PreferencesPage />} />
          <Route path="server" element={<ServerPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="user/:id/connections" element={<UserConnectionsPage />} />
          <Route path="user/:id" element={<UserPage />} />
          <Route path="user" element={<UserPage />} />
          {/* MODS */}
{/*           <Route path="updates" element={<UpdatesPage />} /> */}
{/*           <Route path="billings" element={<BillingsPage />} /> */}
{/*           <Route path="billing/:id" element={<BillingPage />} /> */}
{/*           <Route path="billing" element={<BillingPage />} /> */}
{/*           <Route path="plans" element={<PlansPage />} /> */}
{/*           <Route path="plan/:id" element={<PlanPage />} /> */}
{/*           <Route path="plan" element={<PlanPage />} /> */}
{/*           <Route path="contracts" element={<ContractsPage />} /> */}
{/*           <Route path="contract/:id" element={<ContractPage />} /> */}
{/*           <Route path="contract" element={<ContractPage />} /> */}
{/*           <Route path="invoices" element={<InvoicesPage />} /> */}
{/*           <Route path="invoice/:id" element={<InvoicePage />} /> */}
{/*           <Route path="invoice" element={<InvoicePage />} /> */}
{/*           <Route path="installations" element={<InstallationsPage />} /> */}
{/*           <Route path="installation/:id" element={<InstallationPage />} /> */}
{/*           <Route path="installation" element={<InstallationPage />} />           */}
          <Route path="revendas" element={<RevendasPage />} />
          <Route path="revenda/:id" element={<RevendaPage />} />
          <Route path="revenda" element={<RevendaPage />} />
          <Route path="whatsapp" element={<WhatsappPage />} />
          <Route path="licenses" element={<LicensesPage />} />
          <Route path="configurator" element={<ConfiguratorPage />} />
          <Route path="costs" element={<CostsPage />} />
          <Route path="cost/:id" element={<CostPage />} />
          <Route path="cost" element={<CostPage />} />
          <Route path="pois" element={<PoisPage />} />
          <Route path="poi/:id" element={<PoiPage />} />
          <Route path="poi" element={<PoiPage />} />
          <Route path="poigroups" element={<PoiGroupsPage />} />
          <Route path="poigroup/:id" element={<PoiGroupPage />} />
          <Route path="poigroup" element={<PoiGroupPage />} />
          {/* Rotas e Roteirizacao */}
          <Route path="routes" element={<RoutesPage />} />
          <Route path="route/:id" element={<RoutePage />} />
          <Route path="route" element={<RoutePage />} />
          <Route path="route-planning" element={<RoutePlanningPage />} />
          <Route path="route-execution" element={<RouteExecutionPage />} />
          <Route path="route-execution/:planId" element={<RouteExecutionPage />} />
          <Route path="operations-center" element={<OperationsCenterPage />} />
          <Route path="routing-dashboard" element={<RoutingDashboardPage />} />
          <Route path="driver-activity" element={<DriverActivityDashboard />} />
          <Route path="driver-score" element={<DriverScoreDashboard />} />
          <Route path="driver-score/:id" element={<DriverScoreDashboard />} />
          <Route path="maintenance-dashboard" element={<MaintenanceDashboard />} />
          {/* Tags Admin - SuperAdmin only */}
          <Route path="tags" element={<TagsAdminPage />} />
        </Route>

        <Route path="reports">
          <Route path="management/speeding" element={<SpeedingPage />} />
          <Route path="management/eco" element={<EcoDrivingPage />} />
          <Route path="management/trips" element={<TripsAnalysisPage />} />
          <Route path="management/positions" element={<PositionsHistoryPage />} />
          <Route path="management/driver" element={<DriverPerformancePage />} />
          <Route path="combined" element={<CombinedReportPage />} />
          <Route path="chart" element={<ChartReportPage />} />
          <Route path="correlation" element={<CorrelationReportPage />} />
          <Route path="events" element={<EventReportPage />} />
          <Route path="geofences" element={<GeofenceReportPage />} />
          <Route path="route" element={<PositionsReportPage />} />
          <Route path="stops" element={<StopReportPage />} />
          <Route path="summary" element={<SummaryReportPage />} />
          <Route path="trips" element={<TripReportPage />} />
          <Route path="scheduled" element={<ScheduledPage />} />
          <Route path="statistics" element={<StatisticsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="logs" element={<LogsPage />} />
          {/* MOD */}
          <Route path="actions" element={<ActionsReportPage />} />
          <Route path="devices" element={<DevicesReportPage />} />
          <Route path="commands" element={<CommandsReportPage />} />
          <Route path="geofences" element={<GeofencesReportPage />} />
          <Route path="costs" element={<CostsReportPage />} />
          <Route path="costsresume" element={<CostsResumeReportPage />} />
        </Route>
      </Route>

      {/* Driver App - PWA Mobile-First */}
      <Route path="/driver" element={<DriverLayout />}>
        <Route index element={<DriverHomePage />} />
        <Route path="routes" element={<DriverRoutesPage />} />
        <Route path="routes/:routeId" element={<DriverRouteExecutionPage />} />
        <Route path="routes/:routeId/execute" element={<DriverRouteExecutionPage />} />
        <Route path="notifications" element={<DriverNotificationsPage />} />
        <Route path="profile" element={<DriverProfilePage />} />
        <Route path="history" element={<DriverRoutesPage />} />
        <Route path="settings" element={<DriverSettingsPage />} />
        <Route path="help" element={<DriverHelpPage />} />
        <Route path="chat" element={<DriverChatPage />} />
        <Route path="chat/:routeId" element={<DriverChatPage />} />
      </Route>
    </Routes>
  );
};

export default Navigation;
